import { z } from 'zod'

export const landingSchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string().min(1),
    slug: z.string().min(1),
    img: z.object({
      data: z.object({
        id: z.number(),
        attributes: z.object({
          url: z.string().min(1),
          formats: z.object({
            thumbnail: z.object({
              url: z.string().min(1),
            }),
          }),
        }),
      }),
    }),
  }),
})

export const schema = z.array(landingSchema)

export type schemaType = z.infer<typeof schema>

export type returnType = ApiServerResponse<schemaType>
